import styled from "@emotion/styled";

export const AuthHeaderWrapper = styled.div`
	display: flex;
	align-items: center;
	margin: 1rem 3rem 0 3rem;
	// margin-left: 3rem;
	// margin-top: 1rem;
	// border-bottom: 1px solid #000;
`;
